import { QRScanner, QRScannerVariant, useQrScanController } from '@my2n/qr-scanner';
import { FormattedMessage } from 'react-intl';
import { QRScanMobileLayout } from '../../QRScanComponents/QRScanMobileLayout';
import messages from './messages';
import { parseRfidQRCode } from './parseRfidQRCode';

interface MobileScanQRProps {
  onClose: () => void;
  onSuccess: (card: string) => void;
  keepLeadingZeros?: boolean;
}

export function MobileScanQR({ keepLeadingZeros, onClose, onSuccess }: MobileScanQRProps) {
  const { error, handleError, handleScan } = useQrScanController({
    onSuccess,
    parseResult: (decoded: string) => parseRfidQRCode(decoded, !!keepLeadingZeros),
  });

  return (
    <QRScanMobileLayout
      closeButtonLabel={<FormattedMessage {...messages.userRfidModalScanQRCloseBtn} />}
      description={<FormattedMessage {...messages.userRfidModalScanQRText} />}
      error={error}
      onClose={onClose}
      scanAlertsMessages={{
        allowCamera: <FormattedMessage {...messages.userRfidModalScanQRAlertAllowCamera} />,
        invalidCode: <FormattedMessage {...messages.userRfidModalScanQRAlertInvalidCode} />,
        permissionDenied: <FormattedMessage {...messages.userRfidModalScanQRAlertPermissionDenied} />,
        timeout: <FormattedMessage {...messages.userRfidModalScanQRAlertTimeout} />,
      }}
      title={<FormattedMessage {...messages.userRfidModalScanQRTitle} />}
    >
      <QRScanner onError={handleError} onScan={handleScan} variant={QRScannerVariant.Mobile} />
    </QRScanMobileLayout>
  );
}
